// src/router/adminGuard.js
import { isAdmin } from "@/services/admin.service";
import { auth } from "@/firebase";
import { isTestModeAllowed } from "@/config/testMode";

// In your admin guard
export const adminGuard = async (to, from, next) => {
  // Skip admin check in Cypress test mode (build-gated; never active in production)
  if (isTestModeAllowed()) {
    // In test mode, check mock admin service if available
    if (window.__mockAdminService) {
      try {
        const adminStatus = await window.__mockAdminService.isAdmin();
        if (
          to.matched.some((record) => record.meta.requiresAdmin) &&
          !adminStatus
        ) {
          next({ path: "/dashboard", query: { unauthorized: "admin" } });
          return;
        }
      } catch (error) {
        console.error("Error in mock admin service:", error);
      }
    }
    next();
    return;
  }

  // Skip admin check for non-admin routes
  if (!to.matched.some((record) => record.meta.requiresAdmin)) {
    next();
    return;
  }

  // If not authenticated yet, let the auth guard handle it
  if (!auth.currentUser) {
    next();
    return;
  }

  try {
    // Check if user is an admin
    const adminStatus = await isAdmin();

    if (adminStatus) {
      next();
    } else {
      next({ path: "/dashboard", query: { unauthorized: "admin" } });
    }
  } catch (error) {
    console.error("Error in admin guard:", error);
    next({ path: "/dashboard", query: { error: "admin_check_failed" } });
  }
};
